import { action, computed, makeObservable, observable } from 'mobx';
import { Store } from '../../store/store';
import { Message, refProxy, StoreNode } from '../../store';

type WindowProps = {
  closeOnOutsideClick?: boolean;
  ignoredTargetOnOutsideClickSelector?: string;
}
export class WindowState
  extends StoreNode {

  isVisible = false;
  isLocked = false;

  constructor(store: Store, props?: WindowProps) {
    super(store, props);
    makeObservable<this, 'handleOpened' | 'handleClosed'>(this, {
      isVisible: observable,
      isLocked: observable,
      ignoredTargetOnOutsideClick: computed,
      closeOnOutsideClick: computed,
      open: action,
      close: action,
      lock: action,
      unlock: action,
      handleCloseButtonClick: action,
      handleMounted: action,
      handleUnmounted: action,
      handleOpened: action,
      handleClosed: action,
    });

    this.refProxy.listen(
      this.refProxyListener);
  }

  get ignoredTargetOnOutsideClick(): string {
    return this.resolvedProps.ignoredTargetOnOutsideClickSelector;
  }

  get closeOnOutsideClick() {
    return this.resolvedProps.closeOnOutsideClick;
  }
  readonly refProxy = refProxy(this);

  open() {
    this.isVisible = true;
  }

  close() {
    this.isVisible = false;
  }

  lock() {
    this.isLocked = true;
  }

  unlock() {
    this.isLocked = false;
  }

  handleCloseButtonClick = (_evt: React.MouseEvent) => {
    this.emit('close');
  }

  handleMounted() { /* noop */ }

  handleUnmounted() { /* noop */ }

  private handleOpened() {
    // console.log('window opened');
    // document.addEventListener('click', this.handleNativeRootClick);

    // mousedown seems to work better in certain scenarios, such as accidentally releasing the click outside of the window / handlers with stop propagation etc.
    document.addEventListener('mousedown', this.handleNativeRootClick);
  }

  private handleClosed() {
    // console.log('window closed');
    // document.removeEventListener('click', this.handleNativeRootClick);
    document.removeEventListener('mousedown', this.handleNativeRootClick);
  }

  private handleNativeRootClick = (evt: MouseEvent) => {
    const node = this.refProxy.node;

    let ignoredTarget: HTMLElement | Element | null = null;
    if (this.ignoredTargetOnOutsideClick) {
      ignoredTarget = document.getElementsByClassName(this.ignoredTargetOnOutsideClick)[0];
    }

    if (node &&
      !node.contains(evt.target as Node) &&
      !ignoredTarget?.contains(evt.target as Node) &&
      // isConnected check needed because some click handlers unmount the clicked element (e.g. speaker input group buttons)
      (evt.target as Node)?.isConnected &&
      this.closeOnOutsideClick !== false) {
      this.emit('outsideClick');
    }
  }

  private refProxyListener = (msg: Message) => {
    switch (msg.type) {
      case 'mounted':
        this.handleOpened();
        break;

      case 'unmounted':
        this.handleClosed();
        break;
    }
  }
}